import actionTypes from '../constants/actionTypes';
import { updateObject } from '../../utils';

const intialState = {
  loading: true,
  error: null,
  subsections: {},
};

const subsectionReducer = (state = intialState, action) => {
  switch (action.type) {
    case actionTypes.START_GET_SUBSECTION:
      return updateObject(state, { loading: true });
    case actionTypes.SUCCESS_GET_SUBSECTION:
      // eslint-disable-next-line no-case-declarations
      const updatedObject = updateObject(state, {
        loading: false,
        subsections: updateObject(state.subsections, {
          [action.subsection.link]: action.subsection,
        }),
        error: null,
      });
      return updatedObject;
    case actionTypes.ERROR_GET_SUBSECTION:
      return updateObject(state, {
        loading: false,
        error: null,
      });
    default:
      return state;
  }
};

export default subsectionReducer;
